import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { LojaIntegradaConnection } from "@/components/screens/Platforms/LojaIntegradaConnection";
import {
  LOJAINTEGRADA_CONNECTION_MESSAGES,
  LojaIntegradaConnectionMessages,
} from "@/messages/platforms/lojaIntegradaConnection/lojaIntegrada-connection.messages";
import translationService from "@/services/translation.service";
import { Language } from "@/types/language.types";

const LojaIntegradaPage: React.FC = () => {
  const { lang = "PT-BR" } = useParams<{ lang?: string }>();
  const [messages, setMessages] = useState<LojaIntegradaConnectionMessages | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadMessages = async () => {
      try {
        const translations = await translationService.get<LojaIntegradaConnectionMessages>(
          LOJAINTEGRADA_CONNECTION_MESSAGES,
          (lang as Language) ?? null
        );
        setMessages(translations);
      } finally {
        setLoading(false);
      }
    };

    loadMessages();
  }, [lang]);

  if (loading) {
    return null; // Loading handled by Suspense in child components
  }

  if (!messages) {
    return <div>Erro ao carregar mensagens</div>;
  }

  return <LojaIntegradaConnection messages={messages} />;
};

export default LojaIntegradaPage;
